export const de = {
  Global: {
    save: 'Speichern',
    savingInProgress: 'Saving in progress DE',
    edit: 'Bearbeiten',
    amend: 'Amend DE',
    editProposal: 'Edit proposal DE',
    delete: 'Löschen',
    cancel: 'Abbrechen',
    confirm: 'Bestätigen',
    proceed: 'Fortfahren',
    assign: 'Zuordnen',
    submit: 'Einreichen',
    accepted: 'Angenommen',
    denied: 'Abgelehnt',
    deny: 'Ablehnen',
    comment: 'Kommentar',
    done: 'Erledigt',
    notDone: 'Nicht erledigt',
    started: 'Gestartet',
    notRelevant: 'Nicht relevant',
    noInfo: 'Keine Informationen',
    addComment: 'Kommentare hinzufügen',
    noComments: 'Keine Kommentare',
    start: 'Beginndatum',
    end: 'Endedatum',
    pending: 'Ausstehend',
    approve: 'Freigeben',
    approved: 'Freigegeben',
    notApproved: 'Nicht freigegeben',
    release: 'Freigabe',
    released: 'Freigegeben',
    notReleased: 'Nicht freigegeben',
    reopen: 'Wieder öffnen',
    requestedBy: 'Angefordert von',
    requestedAt: 'Angeforderte am',
    proposedDecision: 'Empfehlung',
    proposedCategory: 'Vorgeschlagene Kategorie',
    proposedSubcategory: 'Vorgeschlagene Unterkategorie',
    search: 'Suche',
    noResults: 'Keine Ergebnisse',
    upload: 'Hochladen',
    uploading: 'Hochladen',
    noFilesUploaded: 'Keine Dateien hochgeladen',
    close: 'Schließen',
    back: 'Zurück',
    next: 'Weiter',
    unknown: 'Unbekannt',
    from: 'Von',
    to: 'Bis',
    logout: 'Abmelden',
    profile: 'Profil',
    group: 'Gruppe',
    code: 'Code',
    confirmationDialogTitle: 'Bestätigung benötigt',
    confirmDeleteFileDialogContent: 'Sind Sie sicher, dass Sie diese Datei löschen wollen?',
    report: 'Bericht',
    unsavedAnswers: 'Sie haben nicht gespeicherten Antworten. Mit der Bestätigung gehen alle gespeicherten Daten verloren.',
    unsavedAnswersActionMode: 'Sie haben nicht gespeicherte Antworten. Möchten Sie sie speichern?',
    noOptions: 'Keine Optionen',
    actionMode: 'Action Mode',
    reason: 'Grund',
    optional: 'Optional',
    choose: 'Auswählen',
    serialNumberMissing: 'Serial number missing DE',
    recipientEmails: 'Recipient Emails (one address per line) DE',
    DatePicker: {
      cancelLabel: 'Abbrechen',
      okLabel: 'Ok',
      minDateMessage: 'Datum sollte nicht vor dem 01.01.1900 liegen.',
      maxDateMessage: 'Datum sollte nicht hinter dem aktuellen Tagsdatum liegen.',
      invalidDateMessage: 'Ungültiges Datumsformat',
    },
    Errors: {
      authErrorTitle: 'Authentifizierungsfehler!',
      authErrorParagraph1: 'Sie sind nicht berechtigt, auf diese App zuzugreifen.',
      authErrorParagraph2: 'Bitte kontaktieren Sie Ihren Administrator.',
      authErrorParagraph3: 'Oder melden Sie sich vom Active Directory ab und versuchen Sie es erneut.',
      pageNotFound: 'Seite nicht gefunden',
      pageNotFoundParagraph1: 'Wir können diese Seite nicht finden.',
      back: 'Startseite',
      rotateDevice: 'Bitte drehen Sie Ihr Gerät.',
    },
    Feedback: {
      error: 'Etwas ist schief gelaufen ... Aktion fehlgeschlagen.',
      authentication: 'Authentifizieren ... bitte warten',
      success: 'Aktion erfolgreich abgeschlossen',
      limitReached: 'Freigabegrenze erreicht',
      requestHasBeenSentToApprover: 'Die Anfrage wurde an den Genehmigenden gesendet.',
      noQuestions: 'Keine Fragen für die ausgewählte Produktfamilie.',
      decisionNotSend: 'Die Entscheidung wurde nicht erfolgreich an SAP gesendet.',
      noLimitForCC: 'Sie haben keine Freigabegrenze für dieses Kundencenter gesetzt.',
      jobCostDoesNotExist:'Jobkosten aus SAP Job ist in der PARS-Datenbank nicht vorhanden.',
      materialNumberBrandDoesNotExist: 'Materialnummer Marke existiert nicht.',
      jobIsLocked: 'Job ist gesperrt.',
      noPicturesAreUploaded: 'Es wurden keine Bilder hochgeladen',
      rateIsProvided: 'Rate wurde erfolgreich registriert',
      rateHasToBeDifferent: 'Die Tarifentscheidung muss anders sein als die alte',
    },
    Status: {
      title: 'Status',
      awaitingEquipment: 'Warenrücksendung offen',
      equipmentReceivedWithDocumentation: 'Warenrücksendung erhalten mit Dokumenten',
      jobReleased: 'Auftrag freigegeben',
      productEvaluation: 'Produktprüfung',
      strippedAndDecontaminated: 'Demontiert und dekontaminiert',
      builtAndTested: 'Montiert und getestet',
      shipped: 'Versendet',
      technicalAndCommercialDecision: 'Technische und kaufmännische Entscheidung',
      finalReportReleased: 'Bericht freigegeben',
      closed: 'Abgeschlossen',
      productInvestigation: 'Produktuntersuchung',
      customerHold: 'Warte auf Kunden',
      notStarted: 'Nicht gestartet',
    },
    Roles: {
      RECEIVING: 'Warenempfänger',
      SERVICE_ENGINEER: 'Servicetechniker',
      FAILURE_ANALYSIS_ENGINEER: 'Fehleranalyse Ingenieur',
      SENIOR_FAILURE_ANALYSIS_ENGINEER: 'Senior fehleranalyse Ingenieur',
      FAILURE_ANALYSIS_MANAGER: 'Fehleranalyse Manager',
      SERVICE_TECHNOLOGY_CENTER_MANAGER: 'STC Manager',
      QUALITY_MANAGER: 'Qualitätsmanager',
      SERVICE_TECHNICAL_SUPPORT_TEAM: 'Service Technical Support Team',
      PRODUCT_COMPANY_TECHNICAL_SUPPORT_TEAM: 'PC Technical Support Team',
      DIVISION_OR_BUSINESS_AREA: 'Division oder Geschäftsbereich',
      CUSTOMER_CENTER: 'Kundencenter',
      CUSTOMER: 'Kunde',
      CUSTOMER_CENTER_SERVICE_ENGINEER: 'Kundencenter Servicetechniker',
      SENIOR_CUSTOMER_CENTER_SERVICE_ENGINEER: 'Senior customer center service engineer DE',
      SUPERADMIN: 'Super Admin',
      ZONE_LEADER: 'Abteilungsleiter',
      QUESTION_ADMIN: 'Fragen Sachbearbeiter',
      DISTRIBUTOR: 'Vertreter',
    },
    Permissions: {
      VIEW_JOB: 'Auftrag anzeigen',
      EDIT_JOB: 'Auftrag bearbeiten',
      IMPORT_JOB_FROM_SAP: 'Auftrag (aus dem SAP) importieren',
      LEVEL_3_RELEASE_FOR_INVESTIGATION: 'Level 3 Freigabe zur Begutachtung',
      LEVEL_4_RELEASE_FOR_INVESTIGATION: 'Level 4 Freigabe zur Begutachtung',
      GENERATE_AND_DOWNLOAD_REPORT: 'Bericht erstellen und herunterladen',
      VIEW_LOG: 'Protokoll anzeigen',
      VIEW_CONVERSATION: 'Gespräch anzeigen',
      PARTICIPATE_IN_CONVERSATION: 'Am Gespräch teilnehmen',
      TAG_INTEREST: 'Markieren',
      ADD_REMOVE_FROM_TEAM: 'Zum Team hinzufügen und aus dem Team entfernen',
      CREATE_JOB: 'Auftrag anlegen',
      DELETE_JOB: 'Auftrag löschen',
      REQUEST_DIFFERENT_REPORT_LEVEL: 'Verschiedene Stufe anfordern',
      APPROVE_DIFFERENT_REPORT_LEVEL: 'Verschiedene Stufe freigeben',
      WARRANTY_DECISION: 'Gewährleistungsentscheidung',
      GOODWILL_DECISION: 'Kulanzentscheidung',
      LEVEL_1_REPORT_APPROVAL: 'Level 1 Bericht Freigabe',
      LEVEL_2_REPORT_APPROVAL: 'Level 2 Bericht Freigabe',
      LEVEL_3_REPORT_APPROVAL: 'Level 3 Bericht Freigabe',
      LEVEL_4_REPORT_APPROVAL: 'Level 4 Bericht Freigabe',
      LEVEL_1_REPORT_REOPEN: 'Level 1 report reopen DE',
      LEVEL_2_REPORT_REOPEN: 'Level 2 report reopen DE',
      LEVEL_3_REPORT_REOPEN: 'Level 3 report reopen DE',
      LEVEL_4_REPORT_REOPEN: 'Level 4 report reopen DE',
      REOPEN_REPORT: 'Bericht wieder öffnen',
      REQUEST_FAILED_PARTS: 'Defekte Teile anfordern',
      SHIP_FAILED_PARTS: 'Defekte Teile versenden',
      PRINT_INPUT_SHEETS: 'Eingabeblätter drucken',
      ADMINISTRATE_QUESTIONS: 'Fragen verwalten',
      ADMINISTRATE_DATA: 'Daten verwalten',
      DOWNLOAD_PICTURES: 'Download pictures DE',
      REQUEST_TECHNICAL_WARRANTY_DECISION: 'Request technical warranty decission DE',
      AMEND_APPROVED_TECHNICAL_DECISION: 'Amend approved technical decision DE',
      AMEND_APPROVED_COMMERCIAL_DECISION: 'Amend approved commercial decision DE',
      ADD_INITIAL_WARRANTY_CODE: 'Add initial warranty code DE',
      RECLASSIFY_TECHNICAL_WARRANTY_CATEGORY: 'Reclassify technical warranty category DE',
      APPROVE_REPORT_LEVEL_4_DOWNGRADE: 'Approve report level 4 downgrade DE',
    },
    Alerts: {
      noAlerts: 'Keine Warnungen',
      healthAndSafetyInformationMissing: 'Gesundheits- und Sicherheits-Informationen fehlen',
      jobNotReleased: 'Auftrag nicht freigegeben',
      noRecentStatusChange: 'Keine aktuelle Statusänderung',
      noServiceTechnicalSupportInvolvement: 'Noch keine Beteiligung des Service Technical Support',
      noProductCompanyTechnicalSupportInvolvement: 'Noch keine Beteiligung des PC Technical Support',
      noTechnicalWarrantyDecision: 'Keine technische Gewährleistungsentscheidung',
      noCommercialDecision: 'Keine kaufmännische Entscheidung',
      reportNotApproved: 'Bericht nicht freigegeben',
    },
    Actions: {
      ADD_JOB: 'Hinzugefügter Auftrag',
      IMPORT_JOB: 'Importierter Auftrag aus SAP',
      DELETE_JOB: 'Gelöschter Auftrag',
      VERIFY_JOB: 'Überprüfter Auftrag',
      SET_PRICE: 'Auftrag bearbeitet- Kosten',
      ADD_TEAM_MEMBER: 'Teammitglied hinzugefügt',
      REMOVE_TEAM_MEMBER: 'Teammitglied entfernt',
      REQUEST_REPORT_LEVEL_CHANGE: 'Angeforderte Stufe Änderung',
      APPROVE_REPORT_LEVEL_CHANGE: 'Freigegebene Stufe Änderung',
      DENY_REPORT_LEVEL_CHANGE: 'Abgelehnte Stufe Änderung',
      REQUEST_REPORT_APPROVAL: 'Angeforderte Bericht zur Freigabe',
      APPROVE_REPORT_APPROVAL: 'Freigegebene Bericht zur Freigabe',
      DENY_REPORT_APPROVAL: 'Abgelehnte Bericht zur Freigabe',
      SET_WARRANTY_START_DATE: 'Geänderter Auftrag - Gewährleistungsstartdatum',
      SET_WARRANTY_END_DATE: 'Bearbeiteter Auftrag - Gewährleistungsenddatum',
      EQUIPMENT_SERIAL_NUMBER_EDITED: 'Bearbeiteter Auftrag - Equipmentsserialnummer',
      MATERIAL_NUMBER_EDITED: 'Bearbeiteter Auftrag - Materialnummer',
      WORKED_ON_JOB: 'Bearbeiteter Auftrag - Fragen aktualisiert',
      UPLOADED_FILE_ON_JOB: 'Bearbeiteter Auftrag - Datei hochgeladen',
      REQUEST_TECHNICAL_WARRANTY_DECISION: 'Technische Gewährleistungsentscheidung angefordert',
      APPROVE_TECHNICAL_WARRANTY_DECISION: 'Technische Gewährleistungsentscheidung freigegeben',
      DENY_TECHNICAL_WARRANTY_DECISION: 'Technische Gewährleistungsentscheidung abgelehnt',
      REQUEST_COMMERCIAL_WARRANTY_DECISION: 'Requested commercial warranty decision',
      APPROVE_COMMERCIAL_WARRANTY_DECISION: 'Kaufmännische Gewährleistungsentscheidung freigegeben',
      NULLIFY_COMMERCIAL_WARRANTY_DECISION: 'Ungültige kaufmännische Gewährleistungsentscheidung',
      DENY_COMMERCIAL_WARRANTY_DECISION: 'Abgelehnte kommerzielle Garantieentscheidung',
      SEND_COMMENT: 'Kommentare hinzugefügt',
      REOPEN_REPORT: 'Bearbeiteter Auftrag  - Bericht wieder öffnen',
      AWAITING_EQUIPMENT_STATUS_SET: 'Status geändert - warte auf Gerät - erledigt',
      AWAITING_EQUIPMENT_STATUS_RESET: 'Status geändert - warte auf Gerät  - nicht erledigt',
      EQUIPMENT_RECEIVED_WITH_DOCUMENTATION_STATUS_SET: 'Status geändert - Gerät erhalten mit Unterlagen - erledigt',
      EQUIPMENT_RECEIVED_WITH_DOCUMENTATION_STATUS_RESET: 'Status geändert - Gerät erhalten mit Unterlagen  - nicht erledigt',
      JOB_RELEASED_STATUS_SET: 'Status geändert - Auftrag freigegeben - erledigt',
      JOB_RELEASED_STATUS_RESET: 'Status geändert - Auftrag freigegeben -nicht fertig',
      PRODUCT_EVALUATION_STATUS_SET: 'Status geändert - Produktprüfung - erledigt',
      PRODUCT_EVALUATION_STATUS_RESET: 'Status geändert - Produktprüfung  - nicht erledigt',
      PRODUCT_INVESTIGATION_STATUS_SET: 'Status geändert - Produktuntersuchung - erledigt',
      PRODUCT_INVESTIGATION_STATUS_RESET: 'Status geändert - Produktuntersuchung  - nicht erledigt',
      STRIPPED_AND_DECONTAMINATED_STATUS_SET: 'Status geändert - demontiert und dekontaminiert - erledigt',
      STRIPPED_AND_DECONTAMINATED_STATUS_RESET: 'Status geändert - demontiert und dekontaminiert  - nicht erledigt',
      BUILT_AND_TESTED_STATUS_SET: 'Status geändert - montiert und getestet - erledigt',
      BUILT_AND_TESTED_STATUS_RESET: 'Status geändert - montiert und getestet  - nicht erledigt',
      SHIPPED_STATUS_SET: 'Status geändert - versendet - erledigt',
      SHIPPED_STATUS_RESET: 'Status geändert - versendet  - nicht erledigt',
      TECHNICAL_AND_COMERCIAL_DECISION_STATUS_SET: 'Status geändert - technische und kaufmännische Entscheidung - erledigt',
      TECHNICAL_AND_COMERCIAL_DECISION_STATUS_RESET: 'Status geändert - technische und kaufmännische Entscheidung  - nicht erledigt',
      FINAL_REPORT_RELEASED_STATUS_SET: 'Status geändert - Bericht freigegeben - erledigt',
      FINAL_REPORT_RELEASED_STATUS_RESET: 'Status geändert - Bericht freigegeben  - nicht erledigt',
      CLOSED_STATUS_SET: 'Status geändert - abgeschlossen - erledigt',
      CLOSED_STATUS_RESET: 'Status geändert - abgeschlossen  - nicht erledigt',
      CUSTOMER_HOLD_STATUS_SET: 'Status geändert - Kunden halten - erledigt',
      CUSTOMER_HOLD_STATUS_RESET: 'Status geändert - Kunden halten  - nicht erledigt',
      REFACTOR_TECHNICAL_WARRANTY_DECISION: 'Technische Gewährleistungskategorie bearbeiten',
      GENERATE_ALERT: 'Alarm generiert',
      INITIAL_WARRANTY_CODE_EDITED: 'Der anfängliche Garantiecode wurde geändert DE',
      AMEND_APPROVED_TECHNICAL_DECISION: 'Amended approved technical warranty decision DE',
      AMEND_APPROVED_COMMERCIAL_DECISION: 'Amended approved commercial decision DE',
      DELETE_APPROVED_TECHNICAL_DECISION: 'Deleted aproved technical warranty decision DE',
      DELETE_APPROVED_COMMERCIAL_DECISION: 'Deleted approved commercial decision DE',
      CHOOSE_RELEASE_METHOD: 'Chose release method DE',
    },
    TechnicalWarranty: {
      ACCEPTED: 'Angenommen',
      DENIED: 'Abgelehnt',
      AGREE: 'Zustimmen',
      DISAGREE: 'Nicht zustimmen',
      MANUFACTURING: 'Herstellung',
      DESIGN: 'Produktdesign',
      VENDOR: 'Lieferant',
      PROCESS: 'Prozess',
      INHOUSE_REPAIR: 'Werkstatt Reparatur',
      FIELD_SERVICE_REPAIR: 'Kundendienst Reparatur',
      NO_FAULT_FOUND: 'Keinen Fehler gefunden',
      WARRANTY_EXPIRED: 'Gewährleistung abgelaufen',
      WARRANTY_EXPIRED_NO_FAULT_FOUND: 'Gewährleistung abgelaufen - Keinen Fehler gefunden',
      WARRANTY_EXPIRED_CUSTOMER_FAULT: 'Gewährleistung abgelaufen - Kundenfehler',
      WARRANTY_EXPIRED_OTHER: 'Gewährleistung abgelaufen - Andere',
      WARRANTY_EXPIRED_COMPONENT_ISSUE: 'Gewährleistung abgelaufen - Komponentenproblem (Edwards Fehler)',
      CUSTOMER_FAULT: 'Kundenfehler',
      OTHER: 'Andere',
      AGREE_WITH_TECHNICAL_WARRANTY_LOG: 'Stimmen Sie der technischen Entscheidung zu',
      DISAGREE_WITH_TECHNICAL_WARRANTY_LOG: 'Nicht einverstanden mit technischer Entscheidung',
      SPARE_PART: 'Spare part (Service Division) DE',
    },
    CommercialWarranty: {
      CONTRACTUAL_AGREEMENT: 'Vertragliche Vereinbarung',
      GOODWILL_ACCEPTED: 'Kulanz akzeptiert',
      CHARGEABLE_TO_CUSTOMER: 'Kostenpflichtig gegenüber dem Kunden',
      EXTENDED_WARRANTY: 'Erweiterte Gewährleistung',
      SERVICE_CONTRACT: 'Servicevertrag',
      OTHER: 'Andere',
      SEMICONDUCTOR: 'Semiconductor',
      SCIENTIFIC: 'Scientific',
      INDUSTRIAL: 'Industrial',
      SEMICONDUCTOR_SERVICE: 'Semiconductor service',
      VACUUM_TECHNIQUE_SERVICE: 'Vacuum technique service',
      SEMICONDUCTOR_CHAMBER_SOLUTIONS: 'Semiconductor Chamber Solutions',
      SEMI_ABATEMENT_AND_INTEGRATED_SYSTEMS: 'Semi Abatement & integrated systems',
      SEMI_ADVANCED_CHEMICAL_MANAGEMENT: 'Semi Advanced Chemical Management',
      SERVICE_CRYOGENICS: 'Service Cryogenics',
      SEMI_DRY_PUMPS: 'Semi Dry Pumps',
      INDUSTRIAL_CUSTOM_DESIGN: 'Industrial custom design',
      INDUSTRIAL_VACUUM: 'Industrial Vacuum',
      SCIENTIFIC_CUSTOM_DESIGN: 'Scientific custom design',
      SEMICON_TURBO_PUMPS: 'Semicon Turbo pumps',
      POLYCOLD: 'Polycold',
    },
    Release: {
      NO_TECHNICAL_TEAM_INVOLVEMENT: 'Keine Beteiligung des technischen Teams notwendig',
      GOLDENEYE_UPLINK: 'Goldeneye überwachen',
      ON_SITE_PRESENCE: 'Vor-Ort-Präsenz',
      RETURN_TO_PRODUCT_COMPANY: 'Zur PC zurücksenden',
      SEND_BACK_PARTS: 'Teile zurück schicken',
    },
    Forms: {
      fields: {
        basicInformation: 'Grundinformation',
        customerCenter: 'Kundencenter',
        serviceTechnologyCenter: 'STC',
        reportLevel: 'Stufe',
        initialWarrantyCode: 'Erster Garantiecode',
        technicalDecision: 'Technische Entscheidung',
        commercialDecision: 'Kaufmännische Entscheidung',
        price: 'Kosten',
        jobStatus: 'Auftragsstatus',
        reportCompletion: 'Bericht abgeschlossen',
        alerts: 'Warnungen',
        team: 'Team',
        customer: 'Kunde',
        customerContact: 'Ansprechpartner Kunde',
        jobDetails: 'Auftragsdetails',
        jobType: 'Auftragstyp',
        serviceProduct: 'Serviceprodukt',
        equipment: 'Equipment',
        failure: 'Fehler',
        symptom: 'Schadensbild',
        address: 'Adresse',
        contactPerson: 'Ansprechpartner',
        email: 'Email',
        phone: 'Telefon',
        customerPurchaseOrderNumber: 'Kundenbestellnummer',
        equipmentWarranty: 'Gerätegarantie',
        serviceWarranty: 'Servicegarantie',
        reportStatus: 'Berichtsstatus',
        reopen: 'Wieder öffnen',
        releaseJob: 'Auftrag freigeben',
        notifyTeam: 'Notify team DE',
      },
      errors: {
        required: 'Pflichtfeld',
        tel: 'Bitte geben Sie eine gültige Telefonnummerein.',
        email: 'Bitte geben Sie eine gültige Email-Adresse ein.',
        number: 'Nur Zahlen sind erlaubt.',
        alphanumeric: 'Keine Sonderzeichen erlaubt',
        text: 'Bitte geben Sie einen gültigen Wert ein.',
        unknown: 'Etwas ist schief gelaufen...',
        belowZero: 'Der Wert darf nicht kleiner als 0 sein.',
        uploadFailed: 'Fehler beim Hochladen',
        maxFileSize: 'Maximal zulässige Größe ist',
              maxLength: maxLength => `Maximal ${maxLength} Zeichen ist zulässig.`,
              minLength: minLength => `Bitte geben Sie mindestens ${minLength} Zeichen ein.`,
      },
    },
    FaultCodes: {
      fallbackDescription: 'Keine Beschreibung für diesen Code',
      jobTypeDescription: {
        'JT001': 'Keine Beschreibung für Auftragsart JT001',
        'JT002': 'Keine Beschreibung für Auftragsart JT002',
      },
      faultCodeDescription: {
        'FC001': 'FC001 Keine Beschreibung für Fehlercode FC001',
        'FC002': 'FC002  Keine Beschreibung für Fehlercode FC002',
      },
      symptomCodeDescription: {
        'SC001': 'SC001  Keine Beschreibung für Schadensbildscode SC001',
        'SC002': 'SC002 Keine Beschreibung für Schadensbildscode SC002',
      },
    },
    Progress: {
      title: 'Fortschritt',
      productReceived: 'Produkt erhalten',
      productEvaluation: 'Produktprüfung',
      stripObservation: 'Demontagebeobachtungen',
      technicalInvestigation: 'Technische Untersuchung',
      conformityTest: 'Konformitätsprüfung',
    },
  },
  Profile: {
    title: 'Profil',
    name: 'Name',
    role: 'Rolle',
    company: 'Unternehmen',
    rights: 'Berechtigung',
    linked: 'Benutzer ist verknüpft mit',
  },
  Jobs: {
    title: 'Aufträge',
    filters: 'Filter',
    myJobs: 'Meine Aufträge',
    otherJobs: 'Andere Aufträge',
    noJobsToDisplay: 'Keine Aufträge zum Anzeigen',
    pleaseUseTheSearchBar: "Please use the search bar. DE",
    id: 'ID',
    createdAt: 'Angelegt am',
    status: 'Status',
    customer: 'Kunde',
    serialProductNumber: 'Service Produkt Nr.',
    materialNumber: 'Material Nr.',
    equipmentSerialNumber: 'Serialnummer',
    customerCenterPlantCode: 'CC',
    serviceTechnologyCenterPlannerGroup: 'STC',
    handledBy: 'Bearbeitet von',
    reportLevel: 'Stufe',
    materialDescription: 'Materialbeschreibung',
    customerName: 'Kundenname',
    receivedDate: 'Empfangsdatum',
    customerCenterName: 'CC Name',
    productReceived: 'Produkt erhalten',
    productEvaluation: 'Produktprüfung',
    stripObservation: 'Demontagebeobachtungen',
    technicalInvestigation: 'Technische Untersuchung',
    conformityTest: 'Konformitätsprüfung',
    workFlow: 'Arbeitsablauf',
    analysisFlow: 'Analysesablauf',
    notificationNumber: 'Meldungsnummer',
    serviceOrderNumber: 'Auftragsnummer',
  },
  Job: {
    editButton: 'Bearbeiten',
    progress: 'Fortschritt',
  },
  Filters: {
    filtersTitle: 'Filter',
    applyButton: 'Anwenden',
    clearButton: 'Löschen',
    sorting: 'Sortierung',
    sortNew: 'Nach Datum sortieren absteigend',
    sortOld: 'Nach Datum sortieren aufsteigend',
    date: 'Datum',
    dateFrom: 'Von',
    dateTo: 'Bis',
    reportLevel: 'Stufe',
    status: 'Status',
    customerNumber: 'Kundennummer',
    customerName: 'Kundenname',
    serviceProductNumber: 'Service Produktnummer',
    materialNumber: 'Materialnummer',
    equipmentSerialNumber: 'Serialnummer',
    stcPlannerGroup: 'STC Planergruppe',
    selectstcPlannerGroup: 'STC Planergruppe auswählen',
    CCplant: 'CC Werk',
    selectCCplant: 'CC Werk auswählen',
    distributor: 'Vertreter',
    selectDistributor: 'Wählen Sie einen Vertreter',
    failureAnalysisEngineerNotAssigned: 'Dem Fehleranalyse Ingenieur nicht  zugeordnet',
    openedJobs: 'Geöffnete Jobs',
    publishedJobs: 'Veröffentlichte Jobs',
    pendingMyApproval: 'Meine ausstehende Freigabe',
    notificationNumber: 'Meldungsnummer',
    unreadMessages: 'Ungelesene Nachrichten',
    serviceOrderNumber: 'Auftragsnummer',
  },
  AddJob: {
    formSections: {
      title: 'Neuen Auftrag hinzufügen',
      createdAt: 'Erstellungsdatum',
      button: 'Speichern',
      basicInformation: {
        title: 'Grundinformation',
        fieldLabels: {
          equipmentSerialNumber: 'Serialnummer',
          serviceTechnologyCenter: 'STC',
          customerCenter: 'Kundencenter',
          reportLevel: 'Stufe',
          initialWarrantyCode: 'Erster Garantiecode',
          customerPurchaseOrderNumber: 'Kundenbestellnummer',
          responsibleSalesPerson: 'Verantwortlicher Vertriebsmitarbeiter',
          customerCenterContactName: 'Kundencenter Ansprechpartner',
          customerCenterContactEmail: 'Kundencenter Kontakt E-mail',
        },
      },
      jobType: {
        title: 'Art',
        fieldLabels: {
          jobType: 'Art',
          jobTypeDescription: 'Beschreibung',
        },
      },
      searchMaterialNumber: 'Nach Materialnummer suchen',
      materialNumber: {
        title: 'Materialnummer',
        fieldLabels: {
          materialNumber: 'Materialnummer',
          materialNumberDescription: 'Beschreibung',
        },
      },
      serviceProductNumber: {
        title: 'Service Produktnummer',
        fieldLabels: {
          serviceProductNumber: 'Service Produktnummer',
          serviceProductNumberDescription: 'Beschreibung',
        },
      },
      symptomCode: {
        title: 'Schadensbildcode',
        fieldLabels: {
          scGroups: 'Schadensbildgruppe',
          symptomCode: 'Schadensbildcode',
          symptomCodeDescription: 'Beschreibung',
        },
      },
      faultCode: {
        title: 'Fehlercode',
        fieldLabels: {
          fcGroups: 'Fehlergruppe',
          faultCode: 'Fehlercode',
          faultCodeDescription: 'Beschreibung',
        },
      },
      customerInformation: {
        title: 'Kundeninformation',
        fieldLabels: {
          customerId: 'Kundennummer',
          customerName: 'Name',
          customerAddress: 'Adresse',
          customerContact: 'Ansprechpartner',
          customerEmail: 'Email-Adresse',
          customerPhone: 'Telefonnummer',
        },
      },
    },
  },
  ImportJob: {
    title: 'Auftrag importieren',
    date: 'Datum des Imports',
    importButton: 'Import',
    searchTitle: 'Suche nach einem Auftrag zum Importieren',
    searchSubtitle: 'Mindestens 5 Zeichen, keine führenden Nullen',
    searchButton: 'Suche',
    notificationNumberLabel: 'Meldungsnummer',
    serviceOrderNumberLabel: 'Auftragsnummer',
    linkTo: 'Link zu',
    openJobsFoundForSerNumber: 'Offene Jobs für diese Seriennummer gefunden',
    importJobAsNew: 'Als neuen Job importieren',
    jobIsImportedAlready: 'Job ist bereits importiert',
    importing: 'Importing in progress... DE',
    linking: 'Linking in progress... DE',
    columns: {
      sourceId: 'Marke',
      notificationNumber: 'Meldungsnummer',
      serviceOrderNumber: 'Auftragsnummer',
      serialNumber: 'Serialnummer',
      jobTypeDescription: 'Beschreibung',
      customerName: 'Kundenname',
    },
  },
  SingleJob: {
    title: 'Auftrag',
    createdAt: 'Angelegt am',
    modifiedAt: 'Zuletzt geändert am',
    serviceOrderNumber: 'Auftragsnummer',
    notificationNumber: 'Meldungsnummer',
    receivedProduct: 'Produkte erhalten',
    productEvaluation: 'Produktprüfung',
    stripObservation: 'Demontagebeobachtungen',
    technicalInvestigation: 'Technische Untersuchung',
    conformityTest: 'Konformitätsprüfung',
    log: 'Protokoll',
    conversation: 'Gespräch',
    noTechPossibilityParagraph1: 'Dieses STC hat keine Prüfkapazität für diesen Auftrag.',
    noTechPossibilityParagraph2: 'Bitte schließen Sie diesen Auftrag und versenden Sie das Equipment an ein anderes STC.',
    downloadPictures: 'Bilder herunterladen',
    downloadAllPictures: 'Alle Bilder herunterladen',
    downloadPicturesFrom: 'Bilder herunterladen von',
    downloadInProgressPleaseWait: 'Download in progress... Please wait DE',
  },
  JobSummary: {
    title: 'Auftragsübersicht',
    createdAt: 'Angelegt am',
    modifiedAt: 'Zuletzt geändert am',
    reportLevelDialogTitle: 'Stufe',
    rateTechnicalDecisionTitle: 'Technische Entscheidung bewerten',
    rateTechnicalDecisionComment: 'Kommentar zur Bewertung der technischen Entscheidung',
    rate: 'Bewerten',
    reclassify: 'Reclassify DE',
    reportLevelDialogContent: 'Setzen Sie die angeforderte Stufe.',
    approveReportLevelDialogTitle: 'Anforderung der Stufe zur Freigabe',
    reportLevelDialogInitialWarrantyCodeLabel: 'Initial warranty code',
    technicalWarrantyDialogTitle: 'Technische Entscheidung vorschlagen',
    editTechnicalWarrantyDialogTitle: 'Edit technical decision proposal DE',
    technicalWarrantyDialogContent: 'Gewährleistungsentscheidung',
    technicalWarrantyDialogCategory: 'Gewährleistungskategorie',
    technicalWarrantyDialogSIBFieldLabel: 'SIB',
    approveTechnicalWarrantyDialogTitle: 'Vorschlag zwecks technischer Gewährleistung freigeben',
    approveTechnicalWarrantyDialogSIBLabel: 'SIB',
    reclassifyTechnicalWarrantyDialogTitle: 'Technische Gewährleistungskategorie neu klassifizieren',
    commercialDecisionDialogTitle: 'Kaufmännische Entscheidung treffen',
    commercialDecisionDialogContent: 'Kaufmännische Entscheidung',
    commercialDecisionDialogCategory: 'Kaufmännische Kategorie',
    approveCommercialDecisionDialogTitle: 'Vorschlag freigeben',
    amendTechnicalWarrantyDecisionDialogTitle: 'Amend technical warranty decision DE',
    amendCommercialDecisionDialogTitle: 'Amend commercial decision DE',
    editPriceDialogTitle: 'Kosten bearbeiten',
    editPriceLabel: 'Bearbeiten',
    releaseJobDialogTitle: 'Auftrag freigegeben',
    proposedDate: 'Vorgeschlagenes Datum',
    releaseJobDialogLabel: 'Verfahren auswählen',
    reportStatusDialogTitle: 'Vorschlag zur  Änderung des Berichtsstatus',
    reportStatusDialogContent: 'Dies wird eine Anforderung erstellen, um den Bericht freizugeben.',
    approveReportStatusDialogContent: 'Sind Sie sicher, dass Sie diesen Auftrag wieder öffnen wollen?',
    approveReportStatusDialogTitle: 'Anforderung zur Berichtsfreigabe',
    chooseReleaseJobMethodTitle: 'Wählen Sie die Release-Job-Methode',
    editChosenReleaseJobMethodTitle: 'Bearbeiten Sie die ausgewählte Release-Job-Methode',
    editJobStatusDialogTitle: 'Auftragsstatus bearbeiten',
    editEquipmentSerialNumberDialogTitle: 'Serialnummer bearbeiten ',
    editEquipmentSerialNumberDialogFieldLabel: 'Serialnummer',
    editMaterialNumberDialogTitle: 'Bearbeiten Materialnummer',
    editMaterialNumberDialogFieldLabel: 'Materialnummer',
    editMaterialNumberDialogDescriptionFieldLabel: 'Beschreibung',
    warrantyStartDialogTitle: 'Bearbeiten Gewährleistungsstartdatum',
    warrantyStartDateLabel: 'Gewährleistungsstartdatum',
    warrantyEndDialogTitle: 'Bearbeiten Gewährleistungsenddatum',
    warrantyEndDateLabel: 'Gewährleistungsenddatum',
    verifyJobDialogTitle: 'Auftrag überprüfen',
    verifyJobDialogContent: 'Diese Maßnahme wird Material- und Equipmentnummern für die Bearbeitung sperren. Sind Sie sicher, dass die folgenden Daten korrekt sind?',
    materialNumber: 'Materialnummer',
    equipmentSerialNumber: 'Serialnummer',
    deleteConfirmationDialogTitle: 'Bestätigung benötigt',
    deleteConfirmationDialogContent: 'Sind Sie sicher, dass Sie diesen Auftrag löschen wollen?',
    teamDialogTitle: 'Teammitglied hinzufügen',
    removeTeamMemberDialogTitle: 'Teammitglied entfernen',
    removeTeamMemberDialogContent: 'Sind Sie sicher, dass Sie dieses Mitglied aus dem Team entfernen möchten?',
    technicalDecisionReason: 'Technischer Entscheidungsgrund',
    warrantyExpiredSubcategoryLabel: 'Out of standard warranty period - Warranty subcategory',
    decisionReason: 'Entscheidungsgrund',
    changeReportLevelReason: 'Grund für die Änderung der Berichtsebene',
    commercialDecisionReason: 'Kaufmännischer Entscheidungsgrund',
    approveReportLevelDialogRequestedLevel: 'Angeforderte Stufe',
    approveReportLevelDialogPreviousLevel: 'Vorherige Stufe',
    approveReportLevelDialogInitialWarrantyCode: 'Erster Garantiecode',
    initialWarrantyCode: 'Erster Garantiecode',
    shipToAddress: 'Sende an folgende Adresse',
    partNumbers: 'Teilenummern',
    failureReason: 'Fehlergrund',
    symptomReason: 'Symptom Grund',
    chooseMethod: 'Methode auswählen',
    chosenMethod: 'Gewählte Methode',
    serialNumberMissingPleaseAdd: 'Serial number missing, please add. DE',
    deleteImportedJob: 'Delete imported DE',
    deleteImportedJobConfirmationDialogContent: 'Are you sure that you want to fully delete this imported job? DE',
  },
  LogSection: {
    title: 'Protokoll',
    sib: 'SIB',
    initialWarrantyCode: 'Erster Garantiecode',
  },
  ReportsDialog: {
    title: 'Bericht erstellen',
    confirmButton: 'Erstellen',
    reportFormat: 'Berichtsformat',
    reportTemplate: 'Berichtsvorlage',
  },
  ActionMode: {
    takePicture: 'Foto machen',
    takeStandardPicture: 'Standardvorlage als Bild',
    takeNonStandardPicture: 'Nicht-Standardvorlage als Bild',
    lastScreenMessage: 'Sie haben das Ende dieses Abschnitts erreicht. Bitte schließen Sie dieses Fenster.',
    lastScreenMessageUnsavedAnswers: 'Sie haben das Ende dieses Abschnitts erreicht. Bitte speichern Sie Ihre Antworten'
  },
  InputFile: {
    special: 'Nicht-Standardvorlage',
    upload: 'Hochladen',
    uploadStandardPicture: 'Standardvorlage als Bild hochladen',
    uploadNonStandardPicture: 'Nicht-Standardvorlage als Bild hochladen',
    commentPicture: 'Bild kommentieren',
    confirmButtonText: 'Kommentar speichern',
    moveFileModal: {
      title: 'Datei bewegen',
      confirmButtonText: 'Bewegen',
      selectSubsection: 'Unterabschnitt auswählen',
      selectQuestion: 'Wähle eine Frage aus',
    },
  },
  FilePreviewModal: {
    moveFileButtonText: 'Bewegen',
  },
}



// WEBPACK FOOTER //
// ./src/constants/translations/de.js